import { render, staticRenderFns } from "./OziConfirmText.vue?vue&type=template&id=6709c79c&scoped=true&"
import script from "./OziConfirmText.vue?vue&type=script&lang=ts&"
export * from "./OziConfirmText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709c79c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions,VCardText})
